export default __webpack_public_path__ + "static/media/cozy_window.b4e75685.png";